<template>
<!--template contents-->
  <div>
    <div class="crystal-chooser container index" v-if="chosenWords.length < 3">
      <header class="page-header">
        <h2 class="entry-title">Choose three words that you are drawn to...</h2>
      </header>
      <div class="cloud-wrapper">
        <vue-word-cloud
          :spacing=.75
          :words="wordsWithWeights"
          :color="([, weight]) => weight > 10 ? '#000000' : weight > 5 ? '#89917c' : '#333'"
          class="cloud"
          font-family="Lato"
          :enter-animation="{opacity: 0,
            transform: 'scale3d(0.1,0.1,0.1)'}"
          :animation-duration=2500
          :animation-overlap=.2
          :font-size-ratio=1.25
        >
          <template slot-scope="{text}">
            <div
              v-bind:class="{ selected: chosenWords.includes(text) || chosenWords.length > 2 }"
              :title="text"
              style="cursor: pointer;"
              @click="selectWord($event, text)"
            >{{ text }}</div>
          </template>
        </vue-word-cloud>
      </div>
      <chosen-words :words="chosenWords" />
    </div>
    <div class="container index" v-if="chosenWords.length>2">
      <results :chosen_crystals="chosenWords" />
      <div class="row">
          <div class="column">
              <a class="btn restart" @click="restart()"><i class="fas fa-undo"></i> Start over</a>
          </div>
      </div>
    </div>
  </div>
<!--/template contents-->
</template>

<script>
import VueWordCloud from "vuewordcloud";
import ChosenWords  from "./components/ChosenWords.vue";
import Results      from "./components/Results.vue";

export default {
  /* Head meta data */
  head() {
    return {
      title: 'Crystal Chooser - Surrender To Happiness',
      meta: [ { hid: 'description', name: 'description', content: 'Find the prefect crystal for you, using our crystal chooser.' } ],
      link: [
        {
          rel: "stylesheet",
          href: "https://fonts.googleapis.com/css?family=Lato&display=swap"
        }
      ],
      bodyAttrs: {
        class: "crystal-chooser"
      }
    };
  },
  /* Child component registration */
  components: {
    VueWordCloud,
    ChosenWords,
    Results
  },

  /* Properties */
  props: [],
  /* Component's local data */

  data() {
    return {
      chosenWords: [],
      words: [
        ["Abundance"],
        ["Clarity"],
        ["Confidence"],
        ["Joy"],
        ["Motivation"],
        ["Balance"],
        ["EMF Protection"],
        ["Healing"],
        ["Harmony"],
        ["Peace"],
        ["Sleep"],
        ["Courage"],
        ["Anxiety"],
        ["Relief"],
        ["Focus"],
        ["Stress Relief"],
        ["Calm"],
        ["Empowerment"],
        ["Patience"],
        ["Forgiveness"],
        ["Love"],
        ["Cleansing"],
        ["Intuition"],
        ["Strength"],
        ["Transformation"],
        ["Growth"],
        ["Release"],
        ["Happiness"],
        ["Manifestation"],
        ["Detox"],
        ["Confidence"],
        ["Protection"],
        ["Grounding"],
        ["Positivity"]
      ],
      wordsWithWeights: []
    };
  },
  /* Watchers */
  watch: {
    chosenWords: function() {
      //
    }
  },

  /* Computed properties */
  computed: {
  },

  /* Component methods */
  methods: {
    selectWord: function(event, word) {
      if (event.target.classList.contains("selected")) return;
      this.chosenWords.push(word);
      event.target;
    },
    addWeights: function() {
      const wordsWithWeights = [];
      this.words.forEach(function(word) {
        wordsWithWeights.push([word[0], Math.floor(Math.random() * 10 + 4 )]);
      });
      this.wordsWithWeights = wordsWithWeights;
    },
    restart: function () {
      console.log(this)
      this.chosenWords = []
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    }
  },
  /* Vue lifecycle hooks:
  Ref: https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks
 */
  created: function() {
    this.addWeights();
  },
  mounted() {},
  updated() {},
  destroyed() {}
};
</script>

<style lang="scss">

  .crystal-chooser {

    margin-top: -60px;
    h2 {
      color: #000000;
      font-size: 20px;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 6.5px;
      text-align: center;
      margin: 0;

      @media (min-width: 576px) {
        margin: 0 0 4rem 0;
      }
    }
  }


  .page-template-page-full-width {
    .elementor-section.elementor-section-boxed > .elementor-container {
      max-width: 100%;
      padding: 0 2rem;
    }
  }
  h3 {
    text-align: center;
  }
  .cloud-wrapper {
    margin-bottom: 2rem;
    height: 50vh;

    @media (min-width: 576px) {
      height: 20vh;
    }

  }

  .btn {
      &.restart {
        margin: 5rem auto;
        cursor: pointer;
        padding: 15px 30px;
        width: auto;
        font-size: 22px;
        font-weight: 400;
        fill: #FFFFFF;
        color: #000 !important;
        border-radius: 0px 0px 0px 0px;
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.07);
        border: 3px solid #000;
      }
    }
</style>
